if (!window.ProductLaunchBlock) {
  window.ProductLaunchBlock = class extends HTMLElement {
    connectedCallback() {
      this.nameInput  = this.querySelector('.bis-name-input');
      this.emailInput = this.querySelector('.bis-email-input');
      this.submitBtn  = this.querySelector('.bis-submit-btn');
      this.successMsg = this.querySelector('.bis-success');
      this.errorMsg   = this.querySelector('.bis-error');
      this.alreadyMsg = this.querySelector('.bis-already');
      this.emailError = this.querySelector('.bis-email-error');
      this.thumbnails = this.querySelectorAll('[data-thumbnail]');
      this.mainSlider = this.querySelector('#' + this.dataset.sliderId);

      this.shopId    = this.dataset.shopId;
      this.variantId = this.dataset.variantId;
      this.lang      = this.dataset.lang;

      if (this.submitBtn) {
        this.submitBtn.addEventListener('click', () => this.handleSubmit());
      }
      if (this.emailInput) {
        this.emailInput.addEventListener('keypress', (e) => {
          if (e.key === 'Enter') this.handleSubmit();
        });
        this.emailInput.addEventListener('input', () => this.resetMessages());
      }

      this.thumbnails.forEach(thumb => {
        thumb.addEventListener('click', () => this.handleThumbnailClick(thumb));
      });

      // Sync thumbnails when carousel scrolls
      this.addEventListener('on:carousel-slider:select', (e) => {
        this.setActiveThumbnail(e.detail.index);
      });
    }

    handleThumbnailClick(thumbnail) {
      const index = parseInt(thumbnail.dataset.index, 10);
      this.setActiveThumbnail(index);

      if (this.mainSlider) {
        const slides = this.mainSlider.querySelectorAll('.slider__item');
        if (slides[index]) {
          this.mainSlider.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
        }
      }
    }

    setActiveThumbnail(index) {
      this.thumbnails.forEach((t, i) => {
        t.classList.toggle('active', i === index);
      });
    }

    validateEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    resetMessages() {
      [this.successMsg, this.errorMsg, this.alreadyMsg, this.emailError].forEach(el => {
        if (el) el.style.display = 'none';
      });
    }

    handleSubmit() {
      this.resetMessages();

      const email = this.emailInput ? this.emailInput.value.trim() : '';
      const name  = this.nameInput  ? this.nameInput.value.trim()  : '';

      if (!this.validateEmail(email)) {
        if (this.emailError) this.emailError.style.display = 'block';
        return;
      }

      this.submitBtn.disabled = true;
      this.submitBtn.style.opacity = '0.7';

      fetch('/apps/es-bis/api/v1/product/add_stock_subscription_via_shopify', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          variant_id: this.variantId,
          email,
          subscriber_name: name,
          is_integration: 0,
          lang: this.lang,
          shop_id: this.shopId
        })
      })
      .then(r => r.json())
      .then(data => {
        this.submitBtn.disabled = false;
        this.submitBtn.style.opacity = '1';
        if (data.code === 0) {
          if (this.successMsg) this.successMsg.style.display = 'block';
          if (this.emailInput) this.emailInput.value = '';
          if (this.nameInput)  this.nameInput.value  = '';
        } else if (data.code === 10) {
          if (this.alreadyMsg) this.alreadyMsg.style.display = 'block';
        } else {
          if (this.errorMsg) this.errorMsg.style.display = 'block';
        }
      })
      .catch(() => {
        this.submitBtn.disabled = false;
        this.submitBtn.style.opacity = '1';
        if (this.errorMsg) this.errorMsg.style.display = 'block';
      });
    }
  };
}

if (!customElements.get('product-launch-block')) {
  customElements.define('product-launch-block', window.ProductLaunchBlock);
}
